import { FC } from 'react';
import { DatePicker } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import { DATE_FORMAT } from '../../../assets/conts';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;

const SRangePicker: FC<RangePickerProps> = (props) => {
  return (
    <RangePicker
      format={DATE_FORMAT}
      placeholder={props.placeholder}
      className={styles.rangePicker}
      onChange={props.onChange}
    />
  );
};

export default SRangePicker;
